import React from "react";
import { VStack } from "@chakra-ui/react";
import { Switch, Form } from "components";
import { useCurrentCase } from "duck";
import { utils, hooks, constants } from "./duck";

const Vaccines: React.FC = () => {
  const initialVaccines = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.vaccines || []
  );

  const update = hooks.useUpdateVaccines(initialVaccines);

  const defaultValues = React.useMemo(
    () => utils.getInitialValues(initialVaccines),
    [initialVaccines]
  );

  if (!initialVaccines) {
    return null;
  }

  return (
    <Form defaultValues={defaultValues}>
      <Form.Watcher defaultValues={defaultValues} onChange={update} />
      <VStack spacing={6}>
        {initialVaccines.map(vaccine => (
          <Switch
            key={vaccine.vaccine}
            name={vaccine.vaccine}
            label={constants.VACCINE_NAME_TO_TITLE[vaccine.vaccine]}
          />
        ))}
      </VStack>
    </Form>
  );
};

export default Vaccines;
